import script from "./PatientMedicationCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientMedicationCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./PatientMedicationCalendar.vue?vue&type=style&index=0&id=6857e968&lang=scss"

const __exports__ = script;

export default __exports__